<template>
  <div>
    <div class="my-3 d-flex justify-content-center">
      <template v-for="(button, index) in config.buttons">
        <b-button
          v-bind:key="index"
          :class="button.class + (button.disabled ? ' default-cursor' : '')"
          :size="config.size"
          :variant="button.variant"
          :disabled="button.disabled"
          pill
          @click.stop="onClick(button)">
          {{ button.text }}
        </b-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
    },
  },
  methods: {
    onClick(button) {
      this.$emit('button-click', { action: button.action, buttonType: button.type, buttonDataType: button.dataType });
    },
  },
};
</script>

<style>
.default-cursor { cursor: default; }
</style>
